import { useMatches } from 'react-router-dom';
import { useCurrentRecordTitle } from '../lib/recordTitle';

/** The app's name, as `index.html`'s `<title>` carries it before any route renders. */
export const APP_NAME = 'Empire Teas CRM';

/** A route's `handle.title`, read from `unknown` by narrowing rather than a cast. */
function titleOf(handle: unknown): string | undefined {
    if (
        typeof handle === 'object' &&
        handle !== null &&
        'title' in handle &&
        typeof handle.title === 'string'
    ) {
        return handle.title;
    }
    return undefined;
}

/**
 * The page title follows the route (design-system §9, WCAG 2.1 SC 2.4.2): the deepest matched route's
 * `handle.title`, then the app name — and on a record page whose record has loaded, the record's name
 * first (`useRecordTitle`, `src/lib/recordTitle.tsx`): `Tea Room — Roles — Empire Teas CRM`. A record
 * route's `handle.title` is its section's name, so the title reads the same before the record loads.
 * React 19 hoists the `<title>` into the document head. A route with no title of its own shows the
 * app name alone.
 */
export function RouteTitle() {
    const matches = useMatches();
    const record = useCurrentRecordTitle();
    let title: string | undefined;
    for (const match of matches) {
        title = titleOf(match.handle) ?? title;
    }
    const parts = [record, title, APP_NAME].filter((part): part is string => part !== undefined);
    return <title>{parts.join(' — ')}</title>;
}
